/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Brayton's Portfolio",
  description: "",
  og: {
    title: "Brayton's Portfolio",
    type: "website",
  },
};

//Home Page
const greeting = {
  title: "Brayton Lordianto",
  websiteLastUpdated: "2024-12-28",
  websitePreviouslyUpdated: "2024-01-11",
  logo_name: "",
  nickname: "#BrayLord",
  subTitle:
    "Graduating Masters of Computer Science Student at UC Berkeley | Web, Mobile, and AR/VR/Computer Graphics Developer",
  resumeLink:
    "https://drive.google.com/open?id=1XYpYhLeqCdyx_q6l0bQoC7RgwQjAjXPf",
  portfolio_repository:
    "https://github.com/Brayton-Lordianto/Brayton-Lordianto.git",
  githubProfile: "https://github.com/Brayton-Lordianto",
  devpostProfile: "https://devpost.com/bl3321",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: greeting.githubProfile,
    fontAwesomeIcon: "fab fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Gmail",
    link: "https://mail.google.com/mail/?view=cm&fs=1&to=bl3321@nyu.edu",
    fontAwesomeIcon: "fa fa-envelope", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "Red", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/brayton-lordianto/",
    fontAwesomeIcon: "fab fa-linkedin", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "Blue", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Web Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "C/C++",
          fontAwesomeClassname: "file-icons:c",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "x86 Assembly",
          fontAwesomeClassname: "vscode-icons:file-type-assembly",
          style: {
            backgroundColor: "white",
            color: "white",
          },
        },
        {
          skillName: "Swift",
          fontAwesomeClassname: "logos:swift",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#61DAFB",
          },
        },
        {
          // webgl
          skillName: "WebGL",
          fontAwesomeClassname: "simple-icons:webgl",
          style: {
            color: "#61DAFB",
          },
        },
        {
          // metal
          skillName: "Metal",
          fontAwesomeClassname: "file-icons:metal",
          style: {
            color: "#61DAFB",
          },
        },
        {
          // webxr
          skillName: "WebXR",
          fontAwesomeClassname: "null",
          style: {
            color: "#61DAFB",
          },
          logo_path: "webxr.png",
        },
        {
          // unity
          skillName: "Unity and C#",
          fontAwesomeClassname: "simple-icons:unity",
          style: {
            color: "#61DAFB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "Google Cloud (Storage + Vision API)",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "CockroachDB",
          fontAwesomeClassname: "simple-icons:cockroachlabs",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "SQL in general",
          fontAwesomeClassname: "ant-design:console-sql-outlined",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB, Mongo Atlas",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            color: "#47A248",
          },
        },

        {
          skillName: "Flask, FastAPI",
          fontAwesomeClassname: "cib:flask",
          style: {
            color: "#47A248",
          },
        },
      ],
    },
    {
      title: "Other",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Canva UI/UX designing",
          fontAwesomeClassname: "simple-icons:canva",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Twilio API",
          fontAwesomeClassname: "logos:twilio-icon",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Blockchain understanding (DeSo, IPFS, etc.)",
          fontAwesomeClassname: "icon-park:blockchain",
          style: {
            backgroundColor: "white",
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/albert_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@albert391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of California, Berkeley (UC Berkeley)",
      subtitle:
        "Masters of Engineering, Electrical Engineering and Computer Science (EECS), Concentration in Visual Computing and Computing Graphics",
      logo_path: "berkeley_logo_golden_dark.png",
      alt_name: "Cal",
      duration: "2024 - 2025",
      descriptions: [
        "🤖 Notable Courses: Machine Learning (289A, Fall ver.), Computer Vision and Computational Photography (280A, 280), Parallel Computers (267), Computer Graphics (284A)",
        "⭐ Awards: $20,000 Fung Excellence Schlarship",
      ],
      website_link: "http://berkeley.edu",
    },
    {
      title: "New York University (NYU)",
      subtitle:
        "Bachelors in Computer Science, GPA: 4.0/4.0, Dean's List 2021-2022",
      logo_path: "nyu_logo_dark.png",
      alt_name: "NYU",
      duration: "2021 - 2024",
      descriptions: [
        "📚 CS/Math Courses: Data Structures, Database Design and Implementation, Object-Oriented Programming, Discrete Mathematics, Linear Algebra, Computer Organization, Parallel Computing, Operating Systems, Computer Security, Theory of Computing, Programming Languages (Graduate), Computer Graphics",
        "🗽 Liberal Studies/General Education Courses: Writing as Exploration I and II, Arts and Cultures I and II and III, Global Works and Society I, II, and III",
        "⚡ CS Activities: Technical Chair for HackNYU Development Team, Research Assistant for BiLab (working in Python), iOS leader/developer at AR Library VIP Team (20+ students), Treasurer/Organizer at Competitive Programming Club ",
        "🤸‍♂️ Other activities: Professional Development Event Organizer at PERMIAS (Indonesian Student Association) NYC, Freshman Representative and Event Organizer at Indonesian Student Association NYU, NYU Table-Tennis Team, Recreational Chess Club (ELO: 1300 - 5 min, 1600 - 1 min)",
      ],
      website_link: "http://nyu.edu",
    },
    {
      title: "Jakarta Intercultural School (JIS)",
      subtitle: "High School Diploma",
      logo_path: "jis_logo_3.png",
      alt_name: "JIS",
      duration: "2019-2021",
      descriptions: [
        "🏅 Canadian Computing Competition - Junior Division 2020 (Certificate of Distinction, top 25%)",
        "🤾‍♂️ Coding Club leader (1yr), Indonesian Club (Vice-President 1.5yr, Secretary 1.5yr)",
      ],
      website_link: "https://www.jisedu.or.id/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Work Experience",
  subtitle: "",
  description:
    "I have worked at Apple and NYU on roles strongly related to my computer science major.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      experiences: [
        {
          title: "Vision Products Group - Messages SWE Intern",
          company: "Apple",
          company_url: "https://www.apple.com/",
          logo_path: "apple_logo.jpg",
          duration: "May 2024 - Sept 2024",
          location: "Sunnyvale, California",
          description:
            "I worked directly on the Messages app on the Vision Pro and iOS teams used by over 1.3 BILLION USERS. I implemented new features and fixed bugs in the app.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Vision Products Group - Software Engineer Intern",
          company: "Apple",
          company_url: "https://www.apple.com/",
          logo_path: "apple_logo.jpg",
          duration: "May 2023 - Sept 2023",
          location: "Sunnyvale, California",
          description:
            "I created an internally shipped Vision Pro visual application using RealityKit, other Swift frameworks, and Metal.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Work",
      experiences: [
        {
          title: "Teaching Assitant - Operating Systems",
          company: "New York University",
          company_url: "https://nyu.edu/",
          logo_path: "nyu_side.jpeg",
          duration: "Sept 2023 - Dec 2023",
          location: "New York, New York",
          description:
            "I hosted class material review sessions and office hours on virtual memory, concurrency, and file systems.",
          color: "#0879bf",
        },
        // {
        //   title: "Android and ML Developer",
        //   company: "Muffito Incorporation",
        //   company_url: "https://www.linkedin.com/company/muffito-inc/about/",
        //   logo_path: "muffito_logo.png",
        //   duration: "May 2018 - Oct 2018",
        //   location: "Pune, Maharashtra",
        //   description:
        //     "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
        //   color: "#9b1578",
        // },
        // {
        //   title: "Android Developer",
        //   company: "FreeCopy Pvt. Ltd.",
        //   company_url: "https://www.linkedin.com/company/freecopy/about/",
        //   logo_path: "freecopy_logo.png",
        //   duration: "Nov 2017 - Dec 2017",
        //   location: "Ahmedabad, Gujarat",
        //   description:
        //     "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
        //   color: "#fc1f20",
        // },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        // {
        //   title: "Google Explore ML Facilitator",
        //   company: "Google",
        //   company_url: "https://about.google/",
        //   logo_path: "google_logo.png",
        //   duration: "June 2019 - April 2020",
        //   location: "Hyderabad, Telangana",
        //   description:
        //     "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
        //   color: "#4285F4",
        // },
        // {
        //   title: "Microsoft Student Partner",
        //   company: "Microsoft",
        //   company_url: "https://www.microsoft.com/",
        //   logo_path: "microsoft_logo.png",
        //   duration: "Aug 2019 - May 2020",
        //   location: "Hyderabad, Telangana",
        //   description:
        //     "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
        //   color: "#D83B01",
        // },
        // {
        //   title: "Mozilla Campus Captain",
        //   company: "Mozilla",
        //   company_url: "https://www.mozilla.org/",
        //   logo_path: "mozilla_logo.png",
        //   duration: "Oct 2019 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
        //   color: "#000000",
        // },
        // {
        //   title: "Developer Students Club Member",
        //   company: "DSC IIITDM Kurnool",
        //   company_url:
        //     "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
        //   logo_path: "dsc_logo.png",
        //   duration: "Jan 2018 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
        //   color: "#0C9D58",
        // },
        // {
        //   title: "Developer Program Member",
        //   company: "Github",
        //   company_url: "https://github.com/",
        //   logo_path: "github_logo.png",
        //   duration: "July 2019 - PRESENT",
        //   location: "Work From Home",
        //   description:
        //     "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
        //   color: "#181717",
        // },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My motive for projects is and always have been to create something that solves problems. I learn my best when doing, so I push myself to use new technologies in projects. Projects include personal and hackathon projects.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://alberthathidara.wordpress.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Budowlanych 48/42, 63-157 Mikołów",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/d/viewer?mid=1iOuLbw9_GB6ZBs8pg61OnElHzQE&hl=en_US",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+48 902922851",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
